import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalToPercent',
  standalone: true,
})
export class DecimalToPercentPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) {
      return '0%';
    }
    const percentValue = Math.round(value * 100);
    return percentValue + '%';
  }
}
